<script setup>
/**
 * FormControlPagesType
 * Composition-based wrapper around the core drop-down select component.
 * Safeguard Layer: Evaluates page creation state on mount, permanently
 * forcing the field to read-only mode for saved entities unless beta is enabled.
 */
import {computed, onMounted} from 'vue'
import FormControlTypeSelect from "@/common/form-control-type/FormControlTypeSelect.vue"
import {useAppStore} from '@/stores/appStore'

const props = defineProps({
    // Standard Orchestrator Props
    formId: {
        type: String,
        required: true
    },
    field: {
        type: Object,
        required: true
    },
    currentData: {
        type: Object,
        required: true
    },
    options: {
        type: Array,
        default: () => []
    }
})

const appStore = useAppStore()

const betaMode = computed(() => appStore.betaMode || false)

onMounted(() => {
    /**
     * Safety Lock Mechanism: If this is an existing database record,
     * lock down modifications to protect structural node mapping rules.
     */
    if (props.currentData?.id && !betaMode.value && props.field) {
        props.field.readonly = true
    }
})
</script>

<template>
    <FormControlTypeSelect v-bind="$props"/>
</template>